import { Tag, Tooltip, useTestIds } from "@homebound/beam";
import { pluralize } from "src/utils";

/** A combination of options that an option is the default for, i.e. `[Modern/White Oak]`. */
export type TargetCombination = { id: string; options: { id: string; name: string }[] };

type TargetCombinationsTagProps = { combinations: TargetCombination[] };

/** Shows a `N target combos` tag for a personalization option, with the combinations themselves in a tooltip. */
export function TargetCombinationsTag(props: TargetCombinationsTagProps) {
  const { combinations } = props;
  const tid = useTestIds({});
  if (combinations.isEmpty) return <Tag {...tid.targetCombinationsTag} text="No combos" type="update" />;
  const count = combinations.length;
  return (
    <Tooltip title={<TargetCombinationsTooltipContent combinations={combinations} />} placement="top">
      <Tag {...tid.targetCombinationsTag} text={`${count} ${pluralize(count, "target combo")}`} type="update" />
    </Tooltip>
  );
}

/** Lists each combination's options, i.e. `[Modern/White Oak]`. */
export function TargetCombinationsTooltipContent(props: TargetCombinationsTagProps) {
  const { combinations } = props;
  const tid = useTestIds(props, "targetCombinationsTooltip");
  return (
    <div {...tid}>
      <div>Target Combinations:</div>
      {combinations.map((combo) => (
        <div key={combo.id} {...tid.combination}>
          [{combo.options.map((o) => o.name).join("/")}]
        </div>
      ))}
    </div>
  );
}
